// import { useEffect, useState } from "react";
// import axiosClient from "../api/axiosClient";
// import { Link } from "react-router-dom";
// import "./../styles/notes.css";

// export default function Notes() {
//   const [notes, setNotes] = useState([]);

//   useEffect(() => {
//     axiosClient.get("/notes").then((res) => setNotes(res.data));
//   }, []);

//   return (
//     <div className="notes-grid">
//       {notes.map((note) => (
        

//         <Link to={`/note/${note.id}`} key={note.id} className="note-card">
//   {/* <img src={note.image_url} alt="" /> */}
//   <h3>{note.title}</h3>
// </Link>

//       ))}
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Chip,
  Fab
} from "@mui/material";
import {
  Notes as NotesIcon,
  Add,
  Description,
  Link as LinkIcon
} from "@mui/icons-material";

export default function Notes() {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        setLoading(true);
        const res = await axiosClient.get("api/notes");
        setNotes(res.data);
      } catch (err) {
        setError("Failed to load notes. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: "center" }}>
        <CircularProgress sx={{ color: "#3E1E68" }} />
        <Typography variant="h6" sx={{ mt: 2, color: "#3E1E68" }}>
          Loading your notes...
        </Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ borderRadius: 2 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, position: "relative" }}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <NotesIcon sx={{ fontSize: 40, color: "#3E1E68" }} />
          <Box>
            <Typography variant="h3" component="h1" fontWeight="bold" color="#3E1E68">
              My Notes
            </Typography>
            <Typography variant="body1" color="text.secondary">
              All your notes in one place
            </Typography>
          </Box>
        </Box>
        <Chip 
          label={`${notes.length} ${notes.length === 1 ? 'Note' : 'Notes'}`}
          sx={{ 
            backgroundColor: "#5D2F77", 
            color: "white",
            fontWeight: "bold",
            fontSize: "1rem"
          }}
        />
      </Box>

      {/* Notes Grid */}
      {notes.length === 0 ? (
        <Box 
          sx={{ 
            textAlign: "center", 
            py: 8,
            background: "linear-gradient(135deg, #3E1E68 0%, #5D2F77 100%)",
            color: "white",
            borderRadius: 3
          }}
        >
          <NotesIcon sx={{ fontSize: 80, mb: 2, opacity: 0.8 }} />
          <Typography variant="h4" gutterBottom fontWeight="bold">
            No Notes Yet
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, mb: 4 }}>
            Start creating your first note to get organized!
          </Typography>
          <Fab
            component={Link}
            to="/add-note"
            variant="extended"
            sx={{
              backgroundColor: "white",
              color: "#3E1E68",
              fontWeight: "bold",
              px: 4,
              "&:hover": {
                backgroundColor: "#f5f5f5",
                transform: "translateY(-2px)",
                boxShadow: 3
              }
            }}
          >
            <Add sx={{ mr: 1 }} />
            Create First Note
          </Fab>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {notes.map((note) => (
            <Grid item xs={12} sm={6} md={4} key={note.id}>
              <Card
                component={Link}
                to={`/note/${note.id}`}
                sx={{
                  textDecoration: "none",
                  height: "100%",
                  // background: "linear-gradient(135deg, #3E1E68 0%, #5D2F77 100%)",
                  background:"#2a1c32ff",
                  color: "white",
                  borderRadius: 3,
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 20px rgba(62, 30, 104, 0.3)",
                    // background: "linear-gradient(135deg, #5D2F77 0%, #3E1E68 100%)"
                    background:"#2a1c32ff",
                  }
                }}
              >
                <CardContent sx={{ p: 3, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                  {/* Note Icon and Type */}
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Description sx={{ mr: 1, opacity: 0.8 }} />
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        Note
                      </Typography>
                    </Box>
                    {note.reference_link && (
                      <LinkIcon sx={{ fontSize: 16, opacity: 0.7 }} />
                    )}
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h6"
                    component="h3"
                    fontWeight="bold"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      mb: 2,
                      flexGrow: 1,
                      minHeight: '64px'
                    }}
                  >
                    {note.title}
                  </Typography>

                  {/* Description Preview */}
                  {note.description && (
                    <Typography
                      variant="body2"
                      sx={{
                        opacity: 0.9,
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        mb: 2
                      }}
                    >
                      {note.description}
                    </Typography>
                  )}

                  {/* Metadata and Click Hint */}
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "auto" }}>
                    <Typography variant="caption" sx={{ opacity: 0.7 }}>
                      {note.created_at && new Date(note.created_at).toLocaleDateString()}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.7, fontStyle: "italic" }}>
                      View →
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Floating Action Button for Adding Notes */}
      {notes.length > 0 && (
        <Fab
          component={Link}
          to="/add-note"
          color="primary"
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            backgroundColor: "#5D2F77",
            color: "white",
            "&:hover": {
              backgroundColor: "#3E1E68",
              transform: "scale(1.1)"
            }
          }}
        >
          <Add />
        </Fab>
      )}
    </Container>
  );
}

